import React, {useContext, useEffect, useState} from 'react';
import ClientsTable from 'features/client/ClientsTable';
import {TitleContext} from '../../components/TitleContext';
import Modal from '../../components/Modal';
import ClientForm from '../../features/client/ClientForm';
import {RootState, AppDispatch} from '../../store/store';
import {useSelector, useDispatch} from 'react-redux';
import {setIsEditing, setClient} from '../../features/client/clientSlice';

const ClientsPage: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setIsModalOpen(false);
    // Reset editing state when modal closes
    dispatch(setIsEditing(false));
    dispatch(setClient(null));
  };
  const client = useSelector((state: RootState) => state.client.client);
  const isEditing = useSelector((state: RootState) => state.client.isEditing);
  const {setTitle} = useContext(TitleContext);
  const [modalTitle, setModalTitle] = useState('New Client:');
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    setTitle(
      <div>
        <div className="text-slate-600 text-lg font-medium font-['Inter']">
          Clients
        </div>
        <div className="text-slate-400 text-sm font-light font-['Inter'] leading-normal">
          Manage your company's clients
        </div>
      </div>,
    );
  }, [setTitle]);

  useEffect(() => {
    if (client && client?.id && isEditing) {
      setModalTitle(`Edit Client: ${client.firstName} ${client.lastName}`);
      setIsModalOpen(true);
    }
  }, [client, isEditing]);

  return (
    <div className="">
      <div className="relative overflow-hidden">
        <div className="relative">
          <ClientsTable openModal={openModal} />
          <Modal isOpen={isModalOpen} onClose={closeModal} title={modalTitle}>
            <ClientForm closeModal={closeModal} />
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default ClientsPage;
